import { ValidationError } from '../../../models';

export function validationErrorHandler(err, vm, info) {
  if (!(err instanceof ValidationError)) return true;

  // vm.$Message.error({ content: 'Validation Error' });

  return false;
}
